// Cliente API de Foco — Django /admin/focus (mismo patrón que performance/api.ts).
import type { FocusItem, FocusMember, FocusToday } from './types';

const DJANGO_PROXY = '/django-api';
const BASE = '/api/v1/admin/focus';

function headers(json = false): Record<string, string> {
  const token = localStorage.getItem('auth_token');
  return { Authorization: `Bearer ${token ?? ''}`, ...(json ? { 'Content-Type': 'application/json' } : {}) };
}

async function asJson<T>(res: Response): Promise<T> {
  if (!res.ok) {
    let msg = `${res.status}`;
    try {
      const b = await res.json();
      msg = b.detail || msg;
    } catch {
      /* noop */
    }
    throw new Error(msg);
  }
  return res.json() as Promise<T>;
}

const get = async <T,>(path: string) => asJson<T>(await fetch(`${DJANGO_PROXY}${BASE}${path}`, { headers: headers() }));
const post = async <T,>(path: string, body: unknown) =>
  asJson<T>(await fetch(`${DJANGO_PROXY}${BASE}${path}`, { method: 'POST', headers: headers(true), body: JSON.stringify(body) }));

export const listItems = (persona = '', incluirCerrados = true) =>
  get<{ total: number; pendientes: FocusItem[] }>(
    `/pendientes?limite=200&incluir_cerrados=${incluirCerrados}${persona ? `&persona=${encodeURIComponent(persona)}` : ''}`,
  );
export const listTeam = () => get<{ equipo: FocusMember[] }>('/equipo');
export const today = (persona = '') => get<FocusToday>(`/hoy${persona ? `?persona=${encodeURIComponent(persona)}` : ''}`);
export const createItem = (body: Record<string, unknown>) => post<{ pendiente: FocusItem }>('/pendientes', { ...body, origen: 'dashboard' });
export const moveItem = (numero: number, estado: string, fecha_limite?: string) =>
  post<{ pendiente: FocusItem }>('/pendientes/mover', { pendiente: String(numero), estado, ...(fecha_limite ? { fecha_limite } : {}) });
export const closeItem = (numero: number, descartar = false) =>
  post<{ pendiente: FocusItem }>('/pendientes/cerrar', { pendiente: String(numero), descartar });
export const editItem = (numero: number, body: Record<string, unknown>) =>
  post<{ pendiente: FocusItem }>('/pendientes/editar', { pendiente: String(numero), ...body });
export const reorder = (estado: string, orden: number[]) => post<{ ok: boolean }>('/tablero/reordenar', { estado, orden });
